import React from 'react'
import { Alert, ListGroup } from 'reactstrap'
import { SubscriptionControllerForm } from '../../ui'
import { provisioningHelpers, subscriptionHelpers } from '../../../dataHelpers'
import '../../../stylesheets/Provision.css'
import Controller from "../../../models/Controller"
import ControllerProvisioningListItem from "./../../ui/ControllerProvisioningListItem"

const PROVISIONING_STATE_STORAGE_KEY = "marksman_controller_provisioning_state"

class SubscriptionController extends React.Component {
    constructor(props) {
        super(props)
        let oldState = { errors: [], loading: false, provisionedControllers: [], reprovisionedControllers: [], usernames: [], passwords: [] }
        let oldStateFromStorage = sessionStorage.getItem(PROVISIONING_STATE_STORAGE_KEY)
        if (oldStateFromStorage) {
            oldState = JSON.parse(oldStateFromStorage)
        }
        this.state = oldState
        this.onSubmit = props.onSubmit
        this.submitForm = this.submitForm.bind(this)
        this.handleWebSocketResponse = this.handleWebSocketResponse.bind(this)
        this.fetchProvisionedControllersState = this.fetchProvisionedControllersState.bind(this)
        this.fetchSubsPlanList = this.fetchSubsPlanList.bind(this)
    }

    componentDidMount() {
        // Kickoff call to get current status of controllers loaded from storage after 1 sec to load token
        setTimeout(() => {
            if (this.props.token) {
                this.fetchProvisionedControllersState()
                this.fetchSubsPlanList()
            }
        }, 1000)
    }

    async fetchProvisionedControllersState() {
        let provisionedControllers = this.state.provisionedControllers
        for (let i = 0; i < provisionedControllers.length; i++) {
            let controller = provisionedControllers[i]
            let searchResponse = await provisioningHelpers.searchSerialNumber(this.props.token, controller.serialNumber)
            if (!searchResponse.error && searchResponse.controller) {
                provisionedControllers[i] = searchResponse.controller
            }
        }
        this.setState({ provisionedControllers })
    }

    async submitForm(selectSubsId, selectSubsName, subsSeasoned, controllerId) {
        this.setState({ loading: true })
        let responses = await this.onSubmit(selectSubsId, selectSubsName, subsSeasoned, controllerId)
        this.setState({ loading: false })
        sessionStorage.setItem(PROVISIONING_STATE_STORAGE_KEY, JSON.stringify(this.state))
    }

    handleWebSocketResponse(data) {
        let result = JSON.parse(data)
        let updatedController = Controller.fromAPIObject(result)
        let filteredControllers = this.state.provisionedControllers.filter((controller) => controller.id !== updatedController.id)
        if (filteredControllers.length < this.state.provisionedControllers.length) {
            let provisionedControllers = filteredControllers
            provisionedControllers.push(updatedController)
            this.setState({ provisionedControllers })
            sessionStorage.setItem(PROVISIONING_STATE_STORAGE_KEY, JSON.stringify(this.state))
        }
    }

    async fetchSubsPlanList() {
        let planlistResponse = await subscriptionHelpers.getPlanList(this.props.token)
        if (!planlistResponse.error) {
            this.setState({ planData: planlistResponse })
        } else {
            this.setState({ errors: [planlistResponse.error] })
        }
    }

    render() {
        let { usernames, passwords, loading, provisionedControllers, reprovisionedControllers, errors, planData } = this.state
        return (<div className="row justify-content-center align-items-center">
            <div className="row justify-content-center align-items-center">
                <h1 className="col-12">Add Subscription to Marksman Controller</h1>
                <br />
                {planData ?
                    <div>
                        <SubscriptionControllerForm planData={planData} onSubmit={(selectSubsId, selectSubsName, subsSeasoned, controllerId) => this.submitForm(selectSubsId, selectSubsName, subsSeasoned, controllerId)} />
                    </div>
                    : null
                }
                <br />
                {errors ? errors.map((error, idx) => (
                    <Alert key={idx} color="danger">
                        {error.text}
                    </Alert>
                )) : null}
                <br />
                {(provisionedControllers.length > 0 ?
                    <div id="provisioned-controllers" className="row justify-content-center align-items-center">
                        <h3 className="col-12">Provisioned Controllers</h3>
                        <ListGroup>
                            {provisionedControllers.map((controller, idx) => (
                                sessionStorage.controllerId = controller.id,
                                <ControllerProvisioningListItem controller={controller}
                                    key={idx}
                                    username={usernames[idx]}
                                    reprovisioned={reprovisionedControllers.includes(controller)}
                                    token={this.props.token}
                                    downloadLoginLink={provisioningHelpers.downloadLinkForLogin(usernames[idx], passwords[idx])}
                                    handleWebSocketResponse={this.handleWebSocketResponse} />
                            ))}
                        </ListGroup>
                    </div>
                    : null)}
            </div>
        </div>)
    }
}
export default SubscriptionController



// WEBPACK FOOTER //
// ./src/components/pages/subscription/SubscriptionController.js